export default __webpack_public_path__ + "static/media/process-timer.f2d8c52c.svg";